<template>
  <apexchart type="bar" :height="height" :options="mergedOptions" :series="series" />
</template>

<script>
import { baseChartOptions, mergeOptions } from "./palette";

export default {
  name: "BarChart",
  props: {
    // [{ name: 'Receiving', data: [1,2,3] }, ...]
    series: { type: Array, required: true },
    categories: { type: Array, default: () => [] },
    horizontal: { type: Boolean, default: false },
    stacked: { type: Boolean, default: false },
    height: { type: [Number, String], default: 320 },
    yTitle: { type: String, default: "" },
    id: { type: String, default: "bar-chart" },
    options: { type: Object, default: () => ({}) }, // apex override
  },
  computed: {
    mergedOptions() {
      const base = baseChartOptions(this.id);
      base.chart.stacked = this.stacked;
      base.plotOptions = { bar: { horizontal: this.horizontal, borderRadius: 4, columnWidth: "55%" } };
      base.xaxis = { categories: this.categories };
      base.yaxis = { title: { text: this.yTitle } };
      return mergeOptions(base, this.options);
    },
  },
};
</script>
